 
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);export default function ParallaxWrapper({
  children,
  offset = 40,     // parallax intensity (y translation in px)
  duration = 0.8,  // slide-in animation duration
  className = "",
  style,
}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

  
    // Parallax movement linked to scroll
    const parallax = gsap.to(el,  {
   y:-100,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });

    return () => {
      parallax.scrollTrigger?.kill();
      parallax.kill();
    };
  }, [offset, duration]);

  return (
    <div
      ref={ref}
      className={`relative will-change-transform ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}
